export default __webpack_public_path__ + "static/media/strogonoff.134f5111.jpg";